import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductMailroomOutlineSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductMailroomOutlineSvg = ({
  ...svgProps
}: ProductMailroomOutlineSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2H4C2.89543 2 2 2.89543 2 4V14C2 15.1046 2.89543 16 4 16H14C15.1046 16 16 15.1046 16 14V4C16 2.89543 15.1046 2 14 2ZM4 1C2.34315 1 1 2.34315 1 4V14C1 15.6569 2.34315 17 4 17H14C15.6569 17 17 15.6569 17 14V4C17 2.34315 15.6569 1 14 1H4Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1.5C5 1.22386 5.22386 1 5.5 1H12.5C12.7761 1 13 1.22386 13 1.5V11.5C13 11.6782 12.9051 11.843 12.751 11.9325C12.5968 12.0219 12.4067 12.0226 12.2519 11.9341L9 10.0759L5.74807 11.9341C5.59332 12.0226 5.40319 12.0219 5.24904 11.9325C5.09488 11.843 5 11.6782 5 11.5V1.5ZM6 2V10.6384L8.75193 9.06588C8.90565 8.97804 9.09435 8.97804 9.24807 9.06588L12 10.6384V2H6Z"
    />
  </SvgWrapper>
);
